var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 2.66659C5.05416 2.66659 2.66634 5.0544 2.66634 7.99992C2.66634 10.9454 5.05416 13.3333 7.99967 13.3333C10.9452 13.3333 13.333 10.9454 13.333 7.99992C13.333 5.0544 10.9452 2.66659 7.99967 2.66659ZM1.33301 7.99992C1.33301 4.31802 4.31778 1.33325 7.99967 1.33325C11.6816 1.33325 14.6663 4.31802 14.6663 7.99992C14.6663 11.6818 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6818 1.33301 7.99992Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 9.33325C7.63148 9.33325 7.33301 9.03478 7.33301 8.66659V7.99992C7.33301 7.63173 7.63148 7.33325 7.99967 7.33325C8.36786 7.33325 8.66634 7.63173 8.66634 7.99992V8.66659C8.66634 9.03478 8.36786 9.33325 7.99967 9.33325Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 10.9999C6.99967 10.4476 7.44739 9.99992 7.99967 9.99992C8.55196 9.99992 8.99967 10.4476 8.99967 10.9999C8.99967 11.5522 8.55196 11.9999 7.99967 11.9999C7.44739 11.9999 6.99967 11.5522 6.99967 10.9999Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25963 5.2075C7.62161 5.17712 7.0866 5.53352 6.9906 6.10952C6.93007 6.4727 6.58659 6.71805 6.22341 6.65752C5.86023 6.59699 5.61488 6.2535 5.67541 5.89032C5.91274 4.46632 7.21107 3.82272 8.32305 3.87567C8.89266 3.9028 9.47804 4.10725 9.9288 4.52844C10.3907 4.9601 10.6663 5.57843 10.6663 6.33325C10.6663 7.19412 10.3276 7.83253 9.74447 8.22129C9.20904 8.57824 8.55269 8.66659 7.99967 8.66659C7.63148 8.66659 7.33301 8.36811 7.33301 7.99992C7.33301 7.63173 7.63148 7.33325 7.99967 7.33325C8.44666 7.33325 8.79031 7.25493 9.00487 7.11189C9.17174 7.00065 9.33301 6.80572 9.33301 6.33325C9.33301 5.92141 9.19194 5.66474 9.01847 5.50265C8.83381 5.33009 8.56503 5.22204 8.25963 5.2075Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleHelp);
export default __webpack_public_path__ + "static/media/circle-help.84abf671e4a17206f36e5b271779349c.svg";
export { ForwardRef as ReactComponent };